module.exports = __webpack_public_path__ + "img/mujer.983a46ba.svg";